// @flow
import axios from 'axios';

import apiFactory from './jiraApi';
import chronosApiFactory from './chronosApi';

axios.interceptors.response.use(r => r.data);
const req = params => axios(params);

const makeRequest = (
  window.AP
    ? (
      url: string,
      options: any = {},
    ) => (
      new Promise((resolve, reject) => {
        window.AP.require('request', (request) => {
          request({
            url,
            type: options.method,
            contentType: 'application/json',
            ...(
              options.data
                ? ({
                  data: options.data,
                }) : {}
            ),
            success: (responseText) => {
              resolve(
                JSON.parse(responseText),
              );
            },
            error: (xhr, statusText, errorThrown) => {
              let jsonResponse = null;
              try {
                jsonResponse = JSON.parse(errorThrown);
              } catch (err) {
                console.log(err);
              }
              if (
                xhr.status === 404
                || xhr.status === 204
              ) {
                return resolve(statusText);
              }
              return reject({ /* eslint-disable-line */
                constructError: true,
                additionalData: {
                  jsonResponse,
                  url,
                  options,
                  responseStatus: xhr.status,
                  responseStatusText: xhr.statusText,
                },
              });
            },
          });
        });
      })
    )
    : (
      url: string,
      options: any = {},
    ) => (
      req({
        url,
        ...options,
      })
    )
);

export const jiraApi = apiFactory({ makeRequest });

export const chronosApi = chronosApiFactory({
  makeRequest: (url, options) => (
    req({
      url,
      ...options,
    })
  ),
});
